<template>
  <router-link :to="{ name: 'ChartsUsersActive' }">
    <doughnut title="Active" :apiData="latest" />
  </router-link>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Doughnut from '@/components/Doughnut'

export default {
  name: 'UsersActiveLatest',
  components: {
    Doughnut,
  },
  methods: {
    ...mapActions('users/active', ['getLatest']),
  },
  computed: {
    ...mapState('users/active', ['latest']),
  },
  async created() {
    this.getLatest()
  },
}
</script>
